<template>
	<div class="card md-elevation-4" style="overflow-x: auto; overflow-y: hidden">
		<div style="padding: 5px; display: flex">
			<el-tooltip>
				<div slot="content">
					<span>{{ $t("profit-overview-description") }}</span>
				</div>
				<span class="tab" :class="{ title: filter_profit }" @click="handleClick('profit')">{{
					$t("profit-overview")
				}}</span>
			</el-tooltip>

			<el-tooltip>
				<div slot="content">
					<span>{{ $t("schools-overview-description") }}</span>
				</div>
				<span class="tab" :class="{ title: filter_schools }" @click="handleClick('school')">{{
					$t("schools-overview")
				}}</span>
			</el-tooltip>

			<div style="margin-top: auto; margin-bottom: auto; display: flex; margin-left: auto; margin-right: 0">
				<div :style="{ display: isMobile ? 'block' : 'flex' }">
					<el-select v-model="filter.from_month" style="width: 125px" @change="searchable = true">
						<el-option
							v-for="(month, index) in MONTHS"
							:key="index"
							:disabled="filter.from_year == filter.to_year && index > MONTHS.indexOf(filter.to_month)"
							:label="month"
							:value="month"
						/>
					</el-select>
					<el-select v-model="filter.from_year" style="width: 85px" @change="searchable = true">
						<el-option
							v-for="(year, index) in YEARS"
							:key="index"
							:disable="year > filter.to_year"
							:label="year"
							:value="year"
						/>
					</el-select>
				</div>
				<div :style="{ display: isMobile ? 'block' : 'flex' }">
					<el-select v-model="filter.to_month" style="width: 125px" @change="searchable = true">
						<el-option
							v-for="(month, index) in MONTHS"
							:key="index"
							:disabled="filter.from_year == filter.to_year && index <= MONTHS.indexOf(filter.from_month)"
							:label="month"
							:value="month"
						/>
					</el-select>
					<el-select v-model="filter.to_year" style="width: 85px" @change="searchable = true">
						<el-option
							v-for="(year, index) in YEARS"
							:key="index"
							:disabled="year < filter.from_year"
							:label="year"
							:value="year"
						/>
					</el-select>
				</div>
				<md-button v-if="searchable" class="md-icon-button" @click="() => handleSearch()">
					<md-icon>search</md-icon>
				</md-button>
			</div>
		</div>
		<apexchart type="area" height="350" ref="charts" :options="area.area_options" :series="area.series_area" />
	</div>
</template>
<script>
import { mapActions, mapGetters } from "vuex"
import moment from "moment"
export default {
	name: "profit-chart",
	data() {
		return {
			area: {
				area_options: {
					chart: { type: "area", toolbar: { show: false } },
					colors: ["#2E93fA", "#66DA26"],
					dataLabels: {
						enabled: false
					},
					labels: this.MONTHS,
					yaxis: []
				},
				series_area: [
					{
						data: []
					}
				]
			},

			series: [],

			config: {
				schools_yaxis: [
					{
						title: {
							text: this.$t("schools")
						}
					}
				],
				profit_yaxis: [
					{
						title: {
							text: this.$t("profit")
						}
					}
				],
				double_yaxis: [
					{
						title: {
							text: this.$t("profit")
						}
					},
					{
						opposite: true,
						title: {
							text: this.$t("schools")
						}
					}
				]
			},

			filter: {
				from_month: undefined,
				from_year: undefined,
				to_month: undefined,
				to_year: undefined
			},
			searchable: false,
			categories: [],
			filter_schools: false,
			filter_profit: true
		}
	},
	computed: {
		...mapGetters({
			payments: "dashboard/range_payments",
			schools: "dashboard/range_schools",
			MONTHS: "dashboard/months",
			YEARS: "dashboard/years"
		}),
		isMobile: function () {
			return window.innerWidth < 850
		}
	},
	async mounted() {
		this.filter = {
			from_year: new Date().getFullYear() - 1,
			to_year: new Date().getFullYear(),
			from_month: this.MONTHS[new Date().getMonth()],
			to_month: this.MONTHS[new Date().getMonth()]
		}
		await this.handleSearch()
	},
	watch: {
		payments: function (val) {
			var data = this.categories.map(item => 0)
			val.forEach(item => {
				var date =
					this.MONTHS[new Date(item.created_at).getMonth() + 1] +
					"-" +
					new Date(item.created_at).getFullYear()

				data[this.categories.indexOf(date)] += item.amount
			})
			var i = -1
			for (var element of this.series) {
				if (element.name == this.$t("profit")) {
					i = this.series.indexOf(element)
					break
				}
			}
			if (i == -1) {
				this.series.push({
					name: this.$t("profit"),
					type: "area",
					data: []
				})
				i = this.series.length - 1
			}
			this.series[i].data = data
			this.$refs.charts.updateSeries(this.series, true, true, true)
		},
		schools: function () {
			var data = this.categories.map(item => 0)
			this.schools.forEach(item => {
				var date = this.MONTHS[new Date(item.created_at).getMonth() + 1] + "-" + new Date().getFullYear()
				data[this.categories.indexOf(date)] += 1
			})
			var i = -1
			for (var element of this.series) {
				if (element.name == this.$t("schoos")) {
					i = this.series.indexOf(element)
					break
				}
			}
			if (i == -1) {
				this.series.push({
					name: this.$t("schools"),
					type: "line",
					data: []
				})
				i = this.series.length - 1
			}
			this.series[i].data = data
			this.$refs.charts.updateSeries(this.series, true, true, true)
		},

		filter_schools: function () {
			if (this.filter_schools && this.filter_profit) {
				this.$refs.charts.updateOptions({ yaxis: this.config.double_yaxis }, true, true, true)
			} else {
				this.$refs.charts.updateOptions({ yaxis: this.config.schools_yaxis }, true, true, true)
			}
			if (this.filter_schools) {
				var payload = {
					to_year: this.filter.to_year + "",
					from_year: this.filter.from_year + "",
					from_month: this.MONTHS.indexOf(this.filter.from_month),
					to_month: this.MONTHS.indexOf(this.filter.to_month)
				}
				this.doFilterSchools(payload)
			} else {
				for (var element of this.series) {
					var i = this.series.indexOf(element)
					if (element.name == this.$t("schools") && i > -1) {
						this.series.splice(i, 1)
						break
					}
				}
				this.$refs.charts.updateSeries(this.series, true, true, true)
			}
		},
		filter_profit: function () {
			if (this.filter_schools && this.filter_profit) {
				this.$refs.charts.updateOptions({ yaxis: this.config.double_yaxis }, true, true, true)
			} else {
				this.$refs.charts.updateOptions({ yaxis: this.config.profit_yaxis }, true, true, true)
			}
			if (this.filter_profit) {
				var payload = {
					to_year: this.filter.to_year + "",
					from_year: this.filter.from_year + "",
					from_month: this.MONTHS.indexOf(this.filter.from_month),
					to_month: this.MONTHS.indexOf(this.filter.to_month)
				}
				this.doFilterPayments(payload)
			} else {
				for (var element of this.series) {
					var i = this.series.indexOf(element)
					if (element.name == this.$t("profit") && i > -1) {
						this.series.splice(i, 1)
						break
					}
				}
				this.$refs.charts.updateSeries(this.series, true, true, true)
			}
		}
	},

	methods: {
		...mapActions({
			doFilterPayments: "dashboard/doFilterPayments",
			doFilterSchools: "dashboard/doSchoolsRange"
		}),
		async handleSearch() {
			this.searchable = false
			this.setCategories()
			var payload = {
				to_year: this.filter.to_year + "",
				from_year: this.filter.from_year + "",
				from_month: this.MONTHS.indexOf(this.filter.from_month),
				to_month: this.MONTHS.indexOf(this.filter.to_month) + 2
			}

			if (this.filter_profit) await this.doFilterPayments(payload)
			if (this.filter_schools) this.doFilterSchools(payload)
		},

		handleClick: function (what) {
			if (what == "profit") {
				if (!this.filter_profit || this.filter_schools) this.filter_profit = !this.filter_profit
			} else {
				if (!this.filter_schools || this.filter_profit) this.filter_schools = !this.filter_schools
			}
		},

		setCategories2: function () {
			var end = moment(new Date(this.filter.to_year, this.MONTHS.indexOf(this.filter.to_month), 1))
			var start = moment(new Date(this.filter.from_year, this.MONTHS.indexOf(this.filter.from_month), 1))
			var diff = end.diff(start, "months", true)
			var categories = []
			for (
				var i = this.MONTHS.indexOf(this.filter.to_month);
				i < diff + this.MONTHS.indexOf(this.filter.to_month);
				i++
			) {
				var k = i >= 12 ? i - 12 : i

				categories.push(
					this.MONTHS[k] + "-" + (this.filter.from_year + parseInt(i >= 12 ? (i - 12) / 12 : i / 12))
				)
			}

			this.$refs.charts.updateOptions({ labels: categories }, true, true, true)
			this.categories = categories

			/*
			var diff_year = this.filter.to_year - this.filter.from_year
			var diff_month = diff_year * 12 + (diff_year > 0 ? 1 : 0)
			diff_month -= this.MONTHS.indexOf(this.filter.from_month) - this.MONTHS.indexOf(this.filter.to_month)
			var categories = []
			var shift = this.MONTHS.indexOf(this.filter.from_month)
			for (var i = shift; i < diff_month + shift; i++) {
				var j = i >= 12 ? 0 : i
				categories.push(this.MONTHS[j] + "-" + (this.filter.from_year + parseInt(i / 12)))
			}
			this.$refs.charts.updateOptions({ labels: categories }, true, true, true)
			this.categories = categories*/
		},

		setCategories: function () {
			var diff_year = this.filter.to_year - this.filter.from_year
			var diff_month = diff_year * 12 + (diff_year > 0 ? 1 : 0) + 1
			diff_month -= this.MONTHS.indexOf(this.filter.from_month) - this.MONTHS.indexOf(this.filter.to_month)
			var categories = []
			var shift = this.MONTHS.indexOf(this.filter.from_month)
			for (var i = shift; i <= diff_month + shift; i++) {
				var j = i > 12 ? (i % 12) - 1 : i % 12
				if (categories.indexOf(this.MONTHS[j] + "-" + (this.filter.from_year + parseInt(i / 12))) == -1) {
					categories.push(this.MONTHS[j] + "-" + (this.filter.from_year + parseInt(i / 12)))
				}
			}
			this.$refs.charts.updateOptions({ labels: categories }, true, true, true)
			this.categories = categories
		}
	}
}
</script>
<style scoped lang="scss">
@import "src/assets/scss/chart.scss";

.tab {
	font-size: 24px;
	margin-top: auto;
	margin-bottom: auto;
	&:hover {
		cursor: pointer;
	}
	margin-left: 5px;
	margin-right: 5px;
}
</style>
